import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { AM_TP_DEMO_ROUTES, TAmDemoPolicyVersionsResponse } from './types';

/**
 * Every demo agreement's version chain for one client, in a single call.
 *
 * The whole company at once because the policies table needs a version chip on every row simultaneously, and
 * because this is the only place a policy row can be matched to the `policyKey` the version-shaped tasks take.
 */
export function useAmTpDemoPolicyVersions(companyId: number | null) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: TAmDemoPolicyVersionsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId
      ? `${AM_TP_DEMO_ROUTES.policyVersions}?companyId=${companyId}`
      : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
